import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=fdd893cc&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=fdd893cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd893cc",
  null
  
)

export default component.exports